export default __webpack_public_path__ + "static/media/landcalender.ac48c5dd.svg";